import React, { useContext, useState } from 'react';

import { Link } from 'react-router-dom';

import PartyPopperUrl from '@pkg/assets/images/Party_Popper.png';
import { Web3AuthContext } from '@pkg/components';
import { DepButton } from '@pkg/components/deprecated';
import { useAppDispatch } from '@pkg/hooks';

import { passwordResetEmail } from '@app/store/actions/auth';

import { Typography } from '../DesignSystem';

import { Container, EmojiImage, FormGroup, FormRow, PrimaryCopySection, Section } from './styles';

export function ForgotPasswordConfirmation() {
    const [resendEmailEnabled, setResendEmailEnabled] = useState(true);
    const { authEmail } = useContext(Web3AuthContext);

    const dispatch = useAppDispatch();

    function handleResendPasswordResetEmail() {
        setResendEmailEnabled(false);
        dispatch(passwordResetEmail(authEmail));
    }

    return (
        <Container>
            <Section>
                <EmojiImage src={PartyPopperUrl} />
            </Section>
            <PrimaryCopySection>
                <Typography type="headline" size={40}>
                    Check your inbox for an email from us!
                </Typography>
                <Typography type="paragraph" size={18} faded={true}>
                    If an account exists under the email, you should have a password reset email in your inbox. No
                    email? Check spam, or try a different email address.
                </Typography>
            </PrimaryCopySection>
            <Section>
                <FormGroup>
                    <FormRow>
                        <DepButton
                            variant="glow"
                            onClick={handleResendPasswordResetEmail}
                            disabled={!resendEmailEnabled}
                        >
                            Resend email
                        </DepButton>
                    </FormRow>
                    <FormRow>
                        <Link to="#having-trouble">Having Trouble?</Link>
                    </FormRow>
                </FormGroup>
            </Section>
        </Container>
    );
}
